"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var FormComponent_1 = require("@/pages/common/components/FormComponent");
var Validator_1 = require("@/utils/Validator");
var ConfirmEmailRegisterFormComponent = /** @class */ (function (_super) {
    __extends(ConfirmEmailRegisterFormComponent, _super);
    function ConfirmEmailRegisterFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlurHandlers = {
            firstname: _this.onBlurHandler('firstname', [Validator_1.fieldRequired('firstname')]),
            lastname: _this.onBlurHandler('lastname', [Validator_1.fieldRequired('lastname')]),
            phoneBody: _this.onBlurHandler('phoneBody', []),
            password: _this.onBlurHandler('password', [Validator_1.fieldRequired('password'), Validator_1.passwordStrength]),
            passwordConfirm: function (password) { return _this.onBlurHandler('passwordConfirm', [
                Validator_1.fieldRequired('passwordConfirm'),
                Validator_1.passwordEquals(password),
            ]); },
        };
        _this.transformBlurHandlers = function (handlers, formState) {
            return __assign(__assign({}, handlers), { passwordConfirm: handlers.passwordConfirm(formState.form.password) });
        };
        return _this;
    }
    ConfirmEmailRegisterFormComponent.prototype.render = function () {
        var _this = this;
        var _a = this.state, ui = _a.ui, tForm = _a.tForm, form = _a.form, showPassword = _a.showPassword;
        var buttonClass = "o-btn o-btn--primary o-btn--long " + (ui.isLoading ? 'o-btn--loading' : '');
        var renderNameErrors = function () {
            return _this.renderError('firstname') ?
                _this.renderError('firstname') :
                _this.renderError('lastname');
        };
        var renderCountryCode = function (code, index) {
            return (React.createElement("option", { key: index, value: code }, code));
        };
        var renderSalutation = function (salutation, index) {
            return (React.createElement("option", { key: index, value: salutation[0] }, salutation[1]));
        };
        var nameRowClass = classnames_1.default('c-forms__row', {
            'u-hidden': ui.defaultForm.firstname && ui.defaultForm.lastname,
        });
        var namePhoneClass = classnames_1.default('c-forms__row', {
            'u-hidden': ui.defaultForm.phoneBody,
        });
        var nameSubscribeClass = classnames_1.default('c-forms__row', {
            'u-hidden': ui.defaultForm.firstname && ui.defaultForm.lastname,
        });
        return (React.createElement("form", { id: "confirmEmailRegisterForm", className: "c-forms", onSubmit: this.onSubmitHandler() },
            this.renderErrors(),
            React.createElement("div", { className: nameRowClass },
                React.createElement("div", { className: "c-forms__cols" },
                    React.createElement("div", { className: "c-forms__col c-forms__col--xs" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("select", { id: "confirmEmailRegisterSalutation", className: "c-forms__input", value: form.salutation, onChange: this.onChangeHandler('salutation'), disabled: ui.isLoading }, ui.salutations.map(function (it, i) { return renderSalutation(it, i); }))))),
                    React.createElement("div", { className: "c-forms__col" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("input", { id: "confirmEmailRegisterInputFirstName", type: "input", className: "c-forms__input", placeholder: tForm.placeholderFirstName, value: form.firstname, onChange: this.onChangeHandler('firstname'), onBlur: this.onBlurHandlers.firstname, disabled: ui.isLoading })))),
                    React.createElement("div", { className: "c-forms__col" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("input", { id: "confirmEmailRegisterInputLastName", type: "input", className: "c-forms__input", placeholder: tForm.placeholderLastName, value: form.lastname, onChange: this.onChangeHandler('lastname'), onBlur: this.onBlurHandlers.lastname, disabled: ui.isLoading }))))),
                renderNameErrors()),
            React.createElement("div", { className: namePhoneClass },
                React.createElement("div", { className: "c-forms__cols" },
                    React.createElement("div", { className: "c-forms__col c-forms__col--xs" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("select", { id: "confirmEmailRegisterInputPhoneCode", className: "c-forms__input", value: form.phoneCode, onChange: this.onChangeHandler('phoneCode'), disabled: ui.isLoading }, ui.dialCodes.map(function (it, i) { return renderCountryCode(it, i); }))))),
                    React.createElement("div", { className: "c-forms__col" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("input", { id: "confirmEmailRegisterInputPhoneBody", type: "input", className: "c-forms__input", placeholder: tForm.placeholderPhoneBody, value: form.phoneBody, onChange: this.onChangeHandler('phoneBody'), onBlur: this.onBlurHandlers.phoneBody, disabled: ui.isLoading }))))),
                this.renderError('phoneBody')),
            React.createElement("div", { className: "c-forms__row" },
                React.createElement("div", { className: "c-forms__cols" },
                    React.createElement("div", { className: "c-forms__col" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("input", { id: "confirmEmailRegisterInputPassword", type: "password", className: "c-forms__input", value: form.password, onChange: this.onChangeHandler('password'), onBlur: this.onBlurHandlers.password, placeholder: tForm.placeholderPassword, disabled: ui.isLoading }))))),
                this.renderError('password')),
            React.createElement("div", { className: "c-forms__row" },
                React.createElement("div", { className: "c-forms__cols" },
                    React.createElement("div", { className: "c-forms__col" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("input", { id: "confirmEmailRegisterInputPasswordConfirm", type: "password", className: "c-forms__input", value: form.passwordConfirm, onChange: this.onChangeHandler('passwordConfirm'), onBlur: this.onBlurHandlers.passwordConfirm(form.password), placeholder: tForm.placeholderPasswordConfirm, disabled: ui.isLoading }))))),
                this.renderError('passwordConfirm')),
            React.createElement("div", { className: nameSubscribeClass },
                React.createElement("div", { className: "c-forms__cols" },
                    React.createElement("div", { className: "c-forms__col" },
                        React.createElement("div", { className: "c-forms__checkbox" },
                            React.createElement("input", { id: "confirmEmailRegsiterCheckboxUpdate", checked: form.subscribe, className: "c-forms__input", type: "checkbox", onChange: this.onChangeHandler('subscribe'), disabled: ui.isLoading }),
                            React.createElement("label", { id: "confirmEmailRegisterCheckboxUpdateFor", htmlFor: "confirmEmailRegsiterCheckboxUpdate" }, tForm.placeholderUpdate))))),
            React.createElement("div", { className: "c-forms__row" },
                React.createElement("div", { className: "c-forms__col c-forms__col--range" },
                    React.createElement("button", { id: "confirmEmailRegisterSubmitButton", disabled: ui.isLoading, className: buttonClass, type: "submit" }, ui.isLoading ? '' : tForm.nameSubmit))),
            React.createElement("div", { className: "c-panel u-text-center u-small-caption l-pad--3" },
                tForm.nameRegisterTermsCaption,
                React.createElement("br", null))));
    };
    return ConfirmEmailRegisterFormComponent;
}(FormComponent_1.default));
exports.default = ConfirmEmailRegisterFormComponent;
